// export const BASE_URL_API = 'https://cors-anywhere.herokuapp.com/https://ctrlpanel.qnnox.com/web/apis';
export const BASE_URL_API = 'https://ctrlpanel.qnnox.com/web/apis';
